'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBrAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "#05AB41" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.53152 10.5597C3.12552 10.297 3.12552 9.70301 3.53152 9.44031L13.6377 2.90103C13.8581 2.75843 14.1416 2.75843 14.362 2.90103L24.4682 9.44031C24.8742 9.70301 24.8742 10.297 24.4682 10.5597L14.362 17.099C14.1416 17.2416 13.8581 17.2416 13.6377 17.099L3.53152 10.5597Z",
          fill: "#FDD216"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0002 14.6666C16.5775 14.6666 18.6668 12.5773 18.6668 9.99998C18.6668 7.42265 16.5775 5.33331 14.0002 5.33331C11.4228 5.33331 9.3335 7.42265 9.3335 9.99998C9.3335 12.5773 11.4228 14.6666 14.0002 14.6666Z",
          fill: "#053087"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.64729 9.19968C9.3332 9.21852 9.21925 9.28224 9.19941 9.2983L8.68132 9.71785L7.84222 8.68166L8.36032 8.26211C8.70684 7.9815 9.16319 7.89299 9.56746 7.86874C9.99139 7.84331 10.4752 7.88299 10.9753 7.956C11.9768 8.10221 13.154 8.39964 14.2558 8.69355C15.4106 9.0016 16.5819 9.47559 17.5428 9.96669C18.0239 10.2126 18.4606 10.467 18.8214 10.7128C19.1714 10.9513 19.489 11.2077 19.6971 11.4647L20.1167 11.9828L19.0805 12.8219L18.6609 12.3038C18.576 12.1989 18.3861 12.0296 18.0707 11.8147C17.7661 11.6072 17.3795 11.3806 16.936 11.1539C16.0476 10.6999 14.9644 10.2625 13.9122 9.98183C12.8069 9.687 11.6984 9.40903 10.7827 9.27534C10.3243 9.20841 9.94172 9.18202 9.64729 9.19968Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagBrAsset = forwardRef(FlagBrAsset);

export { VpFlagBrAsset as default };
